module.exports = __webpack_public_path__ + "img/Finale2.a50ba0fa.jpg";